import { InfoIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Alert, AlertDescription } from '@/components/ui/alert';
import { cn } from '@/lib/utils';

interface Props {
  className?: string;
}

export const ReadOnlyBanner = ({ className }: Props) => {
  const { t } = useTranslation();

  return (
    <Alert
      variant="info"
      role="status"
      className={cn(
        'flex items-center justify-center rounded-none p-2 has-[>svg]:gap-x-2 [&>svg]:translate-y-0',
        className
      )}
    >
      <InfoIcon size={16} className="shrink-0" />
      <AlertDescription className="leading-5">{t('permissions.read_only')}</AlertDescription>
    </Alert>
  );
};
